import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// REDUX
import {
  cancelOrderThunk,
  finishOrderThunk,
  selectAllOrders,
  setShowOrderInfosModal,
  setShowResetCountModal,
  updateOrders,
} from "../../store/actions/ordersSlice";

//APP COMPONENTS
import ResetCountModal from "../modals/resetCount";
import NewOrderSoundAlert from "../songs/alert";
import MobileOrderInfoModal from "../orders/MobileOrderInfoModal";
import InfoModal from "../orders/infoModal";

export default function OrderManager() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const showResetCountModal = useSelector(
    (state) => state.orders.showResetCountModal
  );

  // Check if there are orders with status_number === 0
  const allOrders = useSelector(selectAllOrders);
  const hasNewOrders = allOrders.some((order) => order.status_number === 0);

  const finishOrderAction = (order) => {
    dispatch(finishOrderThunk({ order }));
  };

  const cancelOrderAction = (order, code, reason) => {
    dispatch(
      cancelOrderThunk({
        order,
        cancelData: {
          code,
          reason,
        },
      })
    );
  };

  const handleUpdateOrderStatus = async (order, action) => {
    try {
      switch (action) {
        case "finish":
          await finishOrderAction(order);
          break;
        default:
          return;
      }
    } catch (e) {
      console.error("Error updating order status:", e);
    }
  };

  const handleCloseInfoModal = async (order, e = null) => {
    try {
      if (order?.order_type === "INDOOR") {
        await dispatch(updateOrders({ newSearch: true }));
      }

      await dispatch(
        setShowOrderInfosModal({
          orderInfosModalOrderId: undefined,
          showOrderInfosModal: false,
        })
      );
    } catch (e) {
      console.error("Error closing info modal:", e);
    }
  };

  const handleShowResetCountModal = () => {
    dispatch(setShowResetCountModal(!showResetCountModal));
  };

  const renderInfoModal = () => {
    if (isMobile) {
      return (
        <MobileOrderInfoModal
          updateOrderStatus={handleUpdateOrderStatus}
          closeModal={handleCloseInfoModal}
          cancelOrder={cancelOrderAction}
        />
      );
    }

    return (
      <InfoModal
        updateOrderStatus={handleUpdateOrderStatus}
        closeModal={handleCloseInfoModal}
        cancelOrder={cancelOrderAction}
      />
    );
  };

  const renderResetCountModal = () => {
    if (!showResetCountModal) {
      return null;
    }

    return <ResetCountModal toggleModal={handleShowResetCountModal} />;
  };

  const renderNewOrderSoundAlert = () => {
    if (!hasNewOrders) {
      return null;
    }

    return <NewOrderSoundAlert />;
  };

  return (
    <>
      {renderInfoModal()}
      {renderResetCountModal()}
      {renderNewOrderSoundAlert()}
    </>
  );
}
